<template>
  <header class="app-header navbar">
    <button class="navbar-toggler mobile-sidebar-toggler d-lg-none" type="button" @click="mobileSidebarToggle">
      <span class="navbar-toggler-icon"></span>
    </button>
    <b-link class="navbar-brand" to="#"></b-link>
    <b-navbar-nav class="ml-auto">
      <b-nav-item href="#/pages/login" class="px-3">{{user.username}} がログインしています</b-nav-item>
      <!-- <b-nav-item href="#/pages/login" class="px-3">{{user.username}} がログインしています</b-nav-item> -->
      <b-nav-item @click="signOut" class="px-3">ログアウト</b-nav-item>
    </b-navbar-nav>
    <button class="navbar-toggler aside-menu-toggler d-md-down-none" type="button" @click="asideToggle">
      <span class="navbar-toggler-icon"></span>
    </button>
  </header>
</template>
<script>
import { Auth, Logger } from "aws-amplify";

import AmplifyStore from "../amplify/AmplifyStore";

const logger = new Logger("SignOutComp");

export default {
  name: 'c-header',
  computed: {
    user() {
      return AmplifyStore.state.user;
    }
  },
  methods: {
    sidebarToggle (e) {
      e.preventDefault()
      document.body.classList.toggle('sidebar-hidden')
    },
    sidebarMinimize (e) {
      e.preventDefault()
      document.body.classList.toggle('sidebar-minimized')
    },
    mobileSidebarToggle (e) {
      e.preventDefault()
      document.body.classList.toggle('sidebar-mobile-show')
    },
    asideToggle (e) {
      e.preventDefault()
      document.body.classList.toggle('aside-menu-hidden')
    },
    signOut (e) {
      // console.dir(AmplifyStore.state.user)
      e.preventDefault()
      Auth.signOut()
        .then(data => {
          logger.debug("sign out success", data);
          AmplifyStore.commit("setUser", null);
          this.$router.push("/auth/signIn");
        })
        .catch(err => logger.error("sign out error", err));
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Header.vue